import { apiClient } from '@/services/API';

const fallbackUrl = require('@/assets/images/placeholder-image.jpg');

export function fallbackImages(count = 1) {
  return Array.from({ length: count }, (_, index) => ({
    id: `fallback-${index}`,
    src: {
      large: fallbackUrl,
      large2x: fallbackUrl,
      original: fallbackUrl,
    },
  }));
}

function responseImages(payload) {
  const images = Array.isArray(payload) ? payload : payload && payload.images;
  if (!Array.isArray(images)) return [];
  return images.filter(
    (image) => image && image.src && image.src.large && image.src.large2x && image.src.original
  );
}

export default {
  async search(params) {
    const response = await apiClient.get('/stock-images/search', { params });
    return responseImages(response.data);
  },
};
